export const FETCHING_COURIERS_LIST = '@@toyota/FETCHING_COURIERS_LIST';
export const FETCHED_COURIERS_LIST = '@@toyota/FETCHED_COURIERS_LIST';
export const FETCHED_COURIERS_LIST_FAILED = '@@toyota/FETCHED_COURIERS_LIST_FAILED';
export const FETCHING_TRANSPORTIST_LIST = '@@toyota/FETCHING_TRANSPORTIST_LIST';
export const FETCHED_TRANSPORTIST_LIST = '@@toyota/FETCHED_TRANSPORTIST_LIST';
export const FETCHED_TRANSPORTIST_LIST_FAILED = '@@toyota/FETCHED_TRANSPORTIST_LIST_FAILED';
export const UPDATING_TRANSPORTIST_LIST = '@@toyota/UPDATING_TRANSPORTIST_LIST';
export const UPDATED_TRANSPORTIST_LIST = '@@toyota/UPDATED_TRANSPORTIST_LIST';
export const UPDATED_TRANSPORTIST_LIST_FAILED = '@@toyota/UPDATED_TRANSPORTIST_LIST_FAILED';
export const DELETING_TRANSPORTIST = '@@toyota/DELETING_TRANSPORTIST';
export const DELETED_TRANSPORTIST = '@@toyota/DELETED_TRANSPORTIST';
export const DELETED_TRANSPORTIST_FAILED = '@@toyota/DELETED_TRANSPORTIST_FAILED';
export const UPDATING_COURIER = '@@toyota/UPDATING_COURIER';
export const UPDATED_COURIER = '@@toyota/UPDATED_COURIER';
export const UPDATED_COURIER_FAILED = '@@toyota/UPDATED_COURIER_FAILED';
export const DELETING_COURIER = '@@toyota/DELETING_COURIER';
export const DELETED_COURIER = '@@toyota/DELETED_COURIER';
export const DELETED_COURIER_FAILED = '@@toyota/DELETED_COURIER_FAILED';
export const FETCHING_DEALERS_AGENCIES_LIST = '@@toyota/FETCHING_DEALERS_AGENCIES_LIST';
export const FETCHED_DEALERS_AGENCIES_LIST = '@@toyota/FETCHED_DEALERS_AGENCIES_LIST';
export const FETCHED_DEALERS_AGENCIES_LIST_FAILED = '@@toyota/FETCHED_DEALERS_AGENCIES_LIST_FAILED';
export const UPDATING_DEALERS_AGENCIES_LIST = '@@toyota/UPDATING_DEALERS_AGENCIES_LIST';
export const UPDATED_DEALERS_AGENCIES_LIST = '@@toyota/UPDATED_DEALERS_AGENCIES_LIST';
export const UPDATED_DEALERS_AGENCIES_LIST_FAILED = '@@toyota/UPDATED_DEALERS_AGENCIES_LIST_FAILED';
export const EXPORTING_TO_EXCEL_COURIERS = '@@toyota/EXPORTING_TO_EXCEL_COURIERS';
export const EXPORTED_TO_EXCEL_COURIERS = '@@toyota/EXPORTED_TO_EXCEL_COURIERS';
export const EXPORTED_TO_EXCEL_COURIERS_FAILED = '@@toyota/EXPORTED_TO_EXCEL_COURIERS_FAILED';
export const EXPORTING_TO_EXCEL_TRANSPORTISTS = '@@toyota/EXPORTING_TO_EXCEL_TRANSPORTISTS';
export const EXPORTED_TO_EXCEL_TRANSPORTISTS = '@@toyota/EXPORTED_TO_EXCEL_TRANSPORTISTS';
export const EXPORTED_TO_EXCEL_TRANSPORTISTS_FAILED = '@@toyota/EXPORTED_TO_EXCEL_TRANSPORTISTS_FAILED';
export const CLEAN_TRANSPORTIST_EXPORT_URL = '@@toyota/CLEAN_TRANSPORTIST_EXPORT_URL';
